import Backbone from 'backbone';
import BackboneDeepModel from '@kahwee/backbone-deep-model';
import Errors from './../../base/errors.js';
import {
  requestUrls
} from './../../../base/vars.js';

export default BackboneDeepModel.extend({
  url: requestUrls.onlineAccountSetup,

  initialize() {
    this.on('error', (model, xhr, options) => {
      this.error(model, xhr, options);
    });
  },

  defaults: {
    AccountInfo: {
      Username: ''
    },
    newPassword: '',
    confirmNewPassword: '',
    resetPwToken: '',
    optInEmailOffers: false,
    optInThirdPartyEmailOffers: false,
    country: ''
  },

  validation: {
    'AccountInfo.Username': {
      required: true,
      minLength: 8,
      maxLength: 16,
      pattern: /^[^(<">'!%\\)]+$/,
      usernameValidation: true
    },
    newPassword: {
      required: true,
      minLength: 2,
      passwordValidation: true
    },
    confirmNewPassword: {
      required: true,
      equalTo: 'newPassword'
    },
    'SeparateConsent.Pipl' :{
      required: (value, attr, computedState) => {
        //Checkbox data-bind
        return (computedState.SeparateConsent && computedState.SeparateConsent.SeparateConsentCheckbox) ? true : false;
      }
    }
  },

  validate(attrs, options) {},

  getData() {
    let data = {};

    data = _.omit(this.attributes, ['AccountInfo', 'Customer', 'TwoFormActionCode', 'countryCode', 'Preferences']);
    data.optInEmailOffers = this.get('optInEmailOffers');
    data.optInThirdPartyEmailOffers = this.get('optInThirdPartyEmailOffers');
    data.userName = this.get('AccountInfo.Username');

    return data;
  },

  save(attrs, options) {
    let requestData = this.getData();

    options = _.extend({
      type: 'POST',
      url: this.url,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(requestData)
    },
    options
    );

    return Backbone.DeepModel.prototype.save.call(this, attrs, options);
  },

  parse(response, options) {
    return _.omit(response, ['confirmNewPassword', 'newPassword', 'resetPwToken', 'userName']);
  },

  error(model, xhr, options) {
    Errors.handleResponse(null, xhr, options);
  }
});
